import { apiClient } from './client';
import type { ApiSuccess, PaginationMeta } from '../types';

export type PaymentStatus = 'pending_client_ops' | 'pending_client_finance' | 'pending_business_head' | 'pending_finance' | 'paid' | 'rejected';

export interface AmPaymentRequest {
  id: number;
  requestCode: string;
  entityType: 'rent' | 'electricity' | 'agreement' | 'discom';
  entityId: number | null;
  stationId: number | null;
  stationName: string | null;
  city: string | null;
  ownerName: string | null;
  clientId: number | null;
  clientName: string | null;
  amount: number;
  purpose: string | null;
  status: PaymentStatus;
  overrideUsed: boolean;
  paymentMode: string | null;
  transactionRef: string | null;
  paidDate: string | null;
  rejectedStage: string | null;
  rejectionReason: string | null;
  createdAt: string;
}

export interface RaisePaymentInput {
  entityType: 'rent' | 'electricity' | 'agreement' | 'discom';
  entityId: number;
  amount?: number;
  purpose?: string;
}

export interface ActPaymentInput {
  action: 'approve' | 'reject' | 'override' | 'pay';
  reason?: string;
  paymentMode?: 'NEFT' | 'RTGS' | 'UPI' | 'Cheque' | 'Cash';
  transactionRef?: string;
  paidDate?: string;
}

export const STATUS_LABEL: Record<PaymentStatus, string> = {
  pending_client_ops: 'Client Ops',
  pending_client_finance: 'Client Finance',
  pending_business_head: 'Business Head',
  pending_finance: 'Finance',
  paid: 'Paid',
  rejected: 'Rejected',
};

export const amPaymentsApi = {
  async list(params: Record<string, unknown> = {}): Promise<{ data: AmPaymentRequest[]; meta: PaginationMeta }> {
    const { data } = await apiClient.get<ApiSuccess<AmPaymentRequest[]>>('/am-payments', { params });
    return { data: data.data, meta: data.meta as PaginationMeta };
  },
  get: async (id: number) => (await apiClient.get<ApiSuccess<AmPaymentRequest>>(`/am-payments/${id}`)).data.data,
  raise: async (body: RaisePaymentInput) => (await apiClient.post<ApiSuccess<AmPaymentRequest>>('/am-payments', body)).data.data,
  act: async (id: number, body: ActPaymentInput) => (await apiClient.post<ApiSuccess<AmPaymentRequest>>(`/am-payments/${id}/act`, body)).data.data,
};
